import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Link, Check } from 'lucide-react';
import { motion } from 'framer-motion';

const PermalinkButton = ({ filters, reducedMotion = false }) => {
  const [copied, setCopied] = useState(false);

  const generatePermalink = () => {
    // Serialize filters to URL params
    const params = new URLSearchParams();
    
    if (filters.dateRange) {
      params.append('start', filters.dateRange.start);
      params.append('end', filters.dateRange.end);
    }
    if (filters.campaign) params.append('campaign', filters.campaign);
    if (filters.variant) params.append('variant', filters.variant);
    if (filters.language) params.append('language', filters.language);
    if (filters.carrier) params.append('carrier', filters.carrier);
    if (filters.timezone) params.append('tz', filters.timezone);
    if (filters.outcome) params.append('outcome', filters.outcome);

    const permalink = `${window.location.origin}${window.location.pathname}?${params.toString()}`;
    
    navigator.clipboard.writeText(permalink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <motion.div
      initial={reducedMotion ? {} : { opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <Button
        onClick={generatePermalink}
        variant="outline"
        size="sm"
        className="text-xs bg-slate-900/50 border-slate-700 hover:border-gold/40"
      >
        {copied ? (
          <>
            <Check className="w-3 h-3 mr-1" />
            Link Copied!
          </>
        ) : (
          <>
            <Link className="w-3 h-3 mr-1" />
            Copy Share Link
          </>
        )}
      </Button>
    </motion.div>
  );
};

export default PermalinkButton;
